import { Injectable } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class LimitsService {

  public customer: CustomerModel;
  constructor(
    private userSession: UserSessionService,
    private webservice: WebservicesService,
    private navigator: Navigator
  ) {

    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    );

  }

  /*
     *  GET /cashier/get-global-payment-limits
    */
  callGetGlobalPaymentLimits() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken
    }
    return this.webservice.get('cashier/get-global-payment-limits', obj);
  }

  public dismiss(): any{
    return this.navigator.dismissAll();
  }
}
